<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <sd-form-field-new label="Почта" class="email">
    <input type="email" class="form-control" placeholder="mail@mail.ru" formControlName="email" />
  </sd-form-field-new>
  <div class="email-consent">
    <sd-toggle formControlName="marketingEmailsConsent">подписываюсь на статьи и все о сервисах</sd-toggle>
  </div>

  @if (isFormEditing()) {
    <div class="change-btn">
      <button
        sdButton
        type="submit"
        [disabled]="this.form.invalid"
        [theme]="buttonThemes.Primary"
        [size]="buttonSizes.Large"
        class="btn btn-save"
      >
        сохранить
      </button>
      <button (click)="onReset()" class="btn-cancel">Отменить изменения</button>
    </div>
  }
</form>
